import React, { useEffect, useRef, useState } from 'react'

import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import PropertyAccordion from '../ui/PropertyAccordion/PropertyAccordion'

interface ITextPropertyConfigProps {
  configuration: Record<string, any>
  onConfigChange: (configUpdater: (prev: any) => any) => void
}

const TextPropertyConfig: React.FC<ITextPropertyConfigProps> = ({
  configuration: propertyConfiguration,
  onConfigChange,
}) => {
  const [multiline, setMultiline] = useState(false)
  const isLocalChangeRef = useRef(false)

  useEffect(() => {
    if (isLocalChangeRef.current) {
      isLocalChangeRef.current = false
      return
    }
    setMultiline(!!propertyConfiguration?.multiline)
  }, [propertyConfiguration])

  const handleMultilineToggle = (checked: boolean) => {
    setMultiline(checked)
    isLocalChangeRef.current = true
    onConfigChange(prev => ({
      ...prev,
      multiline: checked,
    }))
  }

  return (
    <PropertyAccordion
      title={Localization.translator.textSettings}
      isDefaultExpanded
    >
      <div className="tw:px-6 tw:py-4 tw:flex tw:flex-col tw:gap-4">
        <div className="tw:flex tw:items-center tw:justify-between tw:w-full tw:text-body-md tw:text-foreground">
          <span>{Localization.translator.enableMultilineInput}</span>
          <Switch checked={multiline} onCheckedChange={handleMultilineToggle} />
        </div>
      </div>
    </PropertyAccordion>
  )
}

export default TextPropertyConfig
